import { yup } from '@/libs/yup';

export const schema = yup.object({
  file: yup.mixed<File>().fileSize().nullable().label('ファイル'),
  mode: yup.string().oneOf(['update', 'delete']).required().label('取込方法')
});

export type Schema = yup.InferType<typeof schema>;
